import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import enhancedAnalytics, {
  captureSessionAcquisition,
  markAnalyticsPageView,
  trackEntryPageView,
} from '../utils/enhancedAnalytics';

function RouteTracker() {
  const location = useLocation();
  const entryRef = useRef(false);

  useEffect(() => {
    captureSessionAcquisition({
      path: location.pathname,
      search: location.search,
    });
    markAnalyticsPageView(location.pathname);
    if (!entryRef.current) {
      entryRef.current = true;
      trackEntryPageView({
        path: location.pathname,
        search: location.search,
      });
    }
    enhancedAnalytics.trackPageView(location.pathname, document.title);
    // Hash changes such as #current-prices are the same route view.
  }, [location.pathname, location.search]);

  return null;
}

export default RouteTracker;
